import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var serializeRules = function serializeRules(rules) {
  return Object.keys(rules).map(function (rule) {
    return "".concat(rule, ":").concat(rules[rule], "!important");
  }).join(';');
};
export var serializeClasses = function serializeClasses(classes) {
  return Object.entries(classes).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      rulesStr = _ref2[1];
    return !!rulesStr;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      className = _ref4[0],
      rulesStr = _ref4[1];
    return ".".concat(className, "{").concat(rulesStr, "}");
  }).join('');
};